<template>
  <div class="page modal-page d-flex flex-column">
    <div class="row header-page">
      <div class="col">
        <h3 class="text-center">
          Invio simulazione al cliente
        </h3>
        <saving-success
          v-if="apiCheckResult === true"
          :email="user.email"
          :pdf="linkPdf"
        ></saving-success>
        <saving-error
          v-if="apiCheckResult === false"
          :email="user.email"
        ></saving-error>
        <div
          v-if="apiCheckResult === null"
          class="row w-100 simulation-form form-group justify-content-md-center"
        >
          <div class="col-4 mt-3">
            <label>Nome</label>
            <b-form-input
              v-model="user.name"
              placeholder="Es: Mario"
            ></b-form-input>
          </div>
          <div class="col-4 mt-3">
            <label>Cognome</label>
            <b-form-input
              v-model="user.surname"
              placeholder="Es: Rossi"
            ></b-form-input>
          </div>
          <div class="col-8 mt-3">
            <label>Email</label>
            <b-form-input
              type="email"
              v-model="user.email"
              placeholder="Es: nome@esempio.com"
              :class="{ 'is-invalid': submitted && !validateEmail() }"
            ></b-form-input>
            <div
              v-show="submitted && !validateEmail()"
              class="invalid-feedback"
            >
              Email non valida
            </div>
          </div>
          <div class="col-8 mt-3">
            <div class="privacy-box" v-dompurify-html="privacyText"></div>
          </div>

          <div class="col-8 mt-5">
            <div class="d-flex flex-row align-items-end">
              <div>
                <b-form-checkbox
                  button-variant="primary"
                  v-model="user.privacy"
                  size="lg"
                  :class="{ 'is-invalid': submitted && !user.privacy }"
                  class="mb-3"
                  >Ho preso visione dell’informativa sulla privacy
                </b-form-checkbox>
                <b-form-checkbox
                  button-variant="primary"
                  v-model="user.profile"
                  size="lg"
                  :class="{ 'is-invalid': submitted && !user.profile }"
                  >Ho compilato il Profilo cliente o è già disponibile
                </b-form-checkbox>
              </div>

              <b-button
                type="submit"
                class="float-right"
                variant="primary ml-auto"
                @click="processData()"
                :disabled="disabledNextStep()"
                >Invia</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PrivacyData } from "../../data/privacy.data";
import { simulationService } from "../../services/simulation.service";
import { getMinAge } from "../../helpers/store.utils";
import SavingSuccess from "../../components/SavingSuccess";
import SavingError from "../../components/SavingError";
import { emailService } from "../../services/email.service";
export default {
  name: "SaveSimulationForm",
  components: { SavingError, SavingSuccess },
  data: () => {
    return {
      val: false,
      modal: false,
      submitted: false,
      showSuccessPage: false,
      showErrorPage: false,
      apiCheckResult: null,
      user: {
        name: "",
        surname: "",
        email: "",
        notes: "",
        privacy: false,
        profile: false
      },
      privacyText: PrivacyData.privacyText,
      linkPdf: "",
      //eslint-disable-next-line
      regExpEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  created() {},
  methods: {
    validateEmail() {
      return this.user.email === "" || this.regExpEmail.test(this.user.email);
    },
    disabledNextStep() {
      return !(
        this.user.name !== "" &&
        this.user.surname !== "" &&
        this.user.email !== "" &&
        this.user.privacy == true &&
        this.user.profile == true
      );
    },
    processData() {
      this.submitted = true;
      if (!this.disabledNextStep() && this.validateEmail()) {
        const simulation = this.createSimulationInput();
        // console.log("simulation", simulation);
        simulationService
          .insertSimulation(simulation)
          .then(res => {
            // console.log("SAVED", res);
            this.$store.commit("setSimulationID", res.data.uuid);
            emailService
              .sendMail(
                res.data.uuid,
                this.user.name,
                this.user.surname,
                this.user.email,
                this.user.privacy,
                this.user.profile
              )
              .then(sentRes => {
                this.apiCheckResult = true;
                this.linkPdf = sentRes.data.export_file;
              })
              .catch(err => {
                console.error(err);
                this.apiCheckResult = false;
              });
          })
          .catch(err => {
            console.error(err);
            this.apiCheckResult = false;
          });
      }
    },
    createSimulationInput() {
      return {
        userInput: {
          age: getMinAge(this.$store.state.ageValue),
          ageRange: this.$store.state.ageValue,
          gender: this.$store.state.genderValue,
          line: "GSS",
          isClientePiuGenerali: this.$store.state.generaliPlusValue,
          servizioBilancia: this.$store.state.generaliBilanciaValue,
          taxOnAccidentPremiums: 0.025,
          issueRights: 10,
          capitalValue: this.$store.state.capitalValue,
          FamilyCareExtraProtection:
            this.$store.state.extraProtectionValue.filter(a => a.id === 3)
              .length > 0,
          FamilyCareExtraProtectionValue:
            this.$store.state.extraProtectionValue.filter(a => a.id === 3)
              .length > 0
              ? this.$store.state.extraProtectionValue.filter(
                  a => a.id === 3
                )[0].value
              : 0,
          TCMPUExtraProtection:
            this.$store.state.extraProtectionValue.filter(a => a.id === 1)
              .length > 0,
          TCMPUExtraProtectionValue:
            this.$store.state.extraProtectionValue.filter(a => a.id === 1)
              .length > 0
              ? this.$store.state.extraProtectionValue.filter(
                  a => a.id === 1
                )[0].value
              : 0,
          ACMAExtraProtection:
            this.$store.state.extraProtectionValue.filter(a => a.id === 2)
              .length > 0,
          ACMAExtraProtectionValue:
            this.$store.state.extraProtectionValue.filter(a => a.id === 2)
              .length > 0
              ? this.$store.state.extraProtectionValue.filter(
                  a => a.id === 2
                )[0].value
              : 0,
          duration: this.$store.state.yearValue,
          tutelaClima:
            this.$store.state.areaValue.filter(a => a.id === 1).length > 0
              ? (2 *
                  this.$store.state.areaValue.filter(a => a.id === 1)[0]
                    .value) /
                this.$store.state.capitalValue
              : 0,
          pariOpportunita:
            this.$store.state.areaValue.filter(a => a.id === 2).length > 0
              ? (2 *
                  this.$store.state.areaValue.filter(a => a.id === 2)[0]
                    .value) /
                this.$store.state.capitalValue
              : 0,
          consumoResponsabile:
            this.$store.state.areaValue.filter(a => a.id === 3).length > 0
              ? (2 *
                  this.$store.state.areaValue.filter(a => a.id === 3)[0]
                    .value) /
                this.$store.state.capitalValue
              : 0,
          saluteBenessere:
            this.$store.state.areaValue.filter(a => a.id === 4).length > 0
              ? (2 *
                  this.$store.state.areaValue.filter(a => a.id === 4)[0]
                    .value) /
                this.$store.state.capitalValue
              : 0,
          crescitaSostenibile:
            this.$store.state.areaValue.filter(a => a.id === 5).length > 0
              ? (2 *
                  this.$store.state.areaValue.filter(a => a.id === 5)[0]
                    .value) /
                this.$store.state.capitalValue
              : 0
        },
        scenarios: this.$store.state.scenarios
      };
    }
  }
};
</script>
